import angular from 'angular';
import ngMessages from 'angular-messages';
import { default as assignControlsToRiskTypeDialog } from 'app/components/global/assignControlsToRiskTypeDialog';
import controller from './edit-risk-type-dialog.controller';
import template from './edit-risk-type-dialog.html';
import nameMessagesTpl from './name.messages.html';
import threatMessagesTpl from './threat.multiplier.messages.html';
import validator, { name as validatorName } from './validators/risk-type-unique-name.validator.directive';

export class dialogService {
  getOptions($event, {
    risk,
    riskOnsets,
    riskForewarnings,
    riskDurations,
    riskDataConfidentialities,
    riskDataIntegrities,
    riskDataAvailabilities,
    riskDirections,
    riskTrendings,
    riskProbabilities,
    riskAssessmentFrequencies,
    riskClassifications,
    assetType,
  }) {
    return {
      controller,
      controllerAs: 'editRiskTypeDialogVM',
      locals: {
        risk,
        riskOnsets,
        riskForewarnings,
        riskDurations,
        riskDataConfidentialities,
        riskDataIntegrities,
        riskDataAvailabilities,
        riskDirections,
        riskTrendings,
        riskProbabilities,
        riskAssessmentFrequencies,
        riskClassifications,
        assetType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
      bindToController: true,
    };
  }
}

export default angular.module('app.components.global.editRiskTypeDialog', [
  ngMessages,
  assignControlsToRiskTypeDialog,
])
  .service('editRiskTypeDialog', dialogService)
  .directive(validatorName, validator)
  .run(($templateCache) => {
    $templateCache.put('riskType.messages.html', nameMessagesTpl);
    $templateCache.put('threat.messages.html', threatMessagesTpl);
  })
  .name;

console.log('app.components.global.editRiskTypeDialog created');
